import { useRouter } from 'next/router';
import { FC } from 'react';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useRedirect } from '@/hooks/useRedirect';
import { ThinEvent } from '@/resources/ThinEvent';

export const LibraryRedirect: FC<{ event?: ThinEvent }> = ({ event }) => {
  const router = useRouter();
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const redirectCondition =
    event?.state === 'post_event' &&
    router.route !== '/events/[eventId]/sessions/[sessionId]/lecture/[lectureId]' &&
    router.route !== '/events/[eventId]/posters/[sessionId]/poster/[posterId]';

  useRedirect(redirectCondition, {
    href: '/events/[eventId]/library',
    asPath: `/events/${eventId}/library`,
    shallow: true,
  });

  return null;
};
